import { forwardRef, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import Grow from '@mui/material/Grow';
import { useSnackbar } from 'notistack';
import { ReactComponent as RawErrorIcon } from 'static/icon/ic-error.svg';
import { ReactComponent as RawCloseIcon } from 'static/icon/ic-close.svg';

const ErrorIcon = styled((props) => (
  <RawErrorIcon width={20} height={20} {...props} />
))`
  flex: 1 0 auto;
  & path {
    fill: ${(props) => props.theme.color.RED_70};
  }
`;
const CloseIcon = styled((props) => (
  <RawCloseIcon width={24} height={24} {...props} />
))`
  flex: 1 0 auto;

  & path {
    fill: ${(props) => props.theme.color.WHITE};
  }
`;

const DefaultContentWrapper = styled('div')`
  box-sizing: border-box;
  padding: 16px 8px 16px 12px;
  border-radius: 4px;
  max-width: 332px;
  min-width: 332px;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;

  background-color: ${(props) => props.theme.color.COOL_GRAY_90};
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 3px 5px rgba(0, 0, 0, 0.2);

  gap: 8px;
`;
const ContentMessageWrapper = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
`;
const MessageWrapper = styled('div')`
  padding: 0 8px 0 4px;

  white-space: pre;
  font-size: 12px;
  line-height: 150%;
  font-weight: 400;
  color: ${(props) => props.theme.color.WHITE};
`;
const ActionWrapper = styled('div')`
  margin: 0 0 0 auto;
  display: flex;
  align-items: center;

  cursor: pointer;
`;

export const messageIconConst = {
  error: 'error',
};
const messageIcon = {
  [messageIconConst.error]: <ErrorIcon />,
};
const DefaultCustomContent = forwardRef((props, ref) => {
  const { closeSnackbar } = useSnackbar();
  const handleDismiss = useCallback(() => {
    closeSnackbar(props.id);
  }, [props.id, closeSnackbar]);

  return (
    <DefaultContentWrapper ref={ref}>
      <ContentMessageWrapper>
        {messageIcon[props.messageIcon]}
        <MessageWrapper>{props.message}</MessageWrapper>
      </ContentMessageWrapper>
      <ActionWrapper>
        <CloseIcon onClick={() => handleDismiss()} />
      </ActionWrapper>
    </DefaultContentWrapper>
  );
});

function useSnackbarStack(
  CustomContentElement = DefaultCustomContent,
  duration
) {
  const { enqueueSnackbar } = useSnackbar();

  const enqueueMessage = useCallback(
    (message, option) =>
      enqueueSnackbar(message, {
        content: (key, message) => (
          <CustomContentElement id={key} message={message} {...option} />
        ),
        TransitionComponent: Grow,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
        autoHideDuration: duration ?? 4000,
        // autoHideDuration: null,
      }),
    [duration, enqueueSnackbar]
  );

  return enqueueMessage;
}

export default useSnackbarStack;
